<template>
  <div></div>
</template>

<script>
import { EventBus } from '../EventBus.js';

export default {
  data () {
    return {
      socket: null
    };
  },
  computed: {
    ticket () {
      return this.$store.state.ws_ticket;
    },
    ticketId () {
      return this.$store.state.ws_ticket.id;
    }
  },
  watch: {
    ticketId () {
      const secure = location.protocol === 'https:';

      if (this.socket) {
        this.socket.disconnect();
      }

      // eslint-disable-next-line no-undef
      this.socket = io(`http${secure ? 's' : ''}://${location.host}/${this.ticket.namespace}`, {
        auth: {
          tid: this.ticket.id,
          client: this.ticket.client,
          namespace: this.ticket.namespace
        }
      });

      // this.io.sendJson = function(msg){
      //   this.send(JSON.stringify(msg));

      //   EventBus.$emit('outgoing msg', {
      //     level: 'i',
      //     message: '',
      //     meta: msg
      //   });
      // }

      this.socket.on('error', function (err) {
        EventBus.$emit('log', {
          level: 'e',
          message: 'webtool socket error (' + err + ')'
        });
      });

      this.socket.on('connect', () => {
        this.$store.commit('SET_CONNECTED', true);

        EventBus.$emit('log', {
          level: 'i',
          message: 'webtool socket connected'
        });

        // subscribe to full namespace messaging firehose
        this.socket.emit('join', 'firehose');
      });

      // this should never fire due to the connection ticket system
      this.socket.on('reconnect', () => {
        this.$store.commit('SET_CONNECTED', true);

        EventBus.$emit('log', {
          level: 'i',
          message: 'webtool socket reconnected'
        });
      });

      this.socket.on('disconnect', () => {
        EventBus.$emit('log', {
          level: 'w',
          message: 'webtool socket disconnected'
        });

        // wipe out socket because we need to re-authenticate
        this.socket.off();
        this.socket.disconnect();
        this.socket = null;

        EventBus.$emit('refresh ticket');

        this.$store.commit('SET_CONNECTED', false);
      });

      this.socket.on('firehose', function (socketId, clientName, level, room, type, meta) {
        EventBus.$emit('log', {
          sender: clientName,
          level,
          channel: room,
          type,
          meta
        });
      });
    }
  },
  created () {
    // listen for send message event
    EventBus.$on('send msg', (json) => {
      if (this.socket && this.socket.connected) {
        this.socket.emit('message', json.channel, json.message);
      }
    });
  },
  beforeDestroy () {
    if (this.socket) this.socket.disconnect();
  }
};
</script>

<style lang="scss">
</style>
